import { ca } from '@cian/analytics';
import { EMapService } from '../../../types/map';

const SERVICE_TO_ANALYTICS_LABEL: Record<string, string> = {
  [EMapService.TransportAccessibility]: 'accessibility_button',
  [EMapService.FutureInfrastructure]: 'future_button',
};

export function trackServiceClick(serviceType: EMapService) {
  ca('eventSite', {
    action: 'click',
    category: 'Infrastructure',
    label: SERVICE_TO_ANALYTICS_LABEL[serviceType],
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
    },
    useLastProducts: true,
  });
}
